import { render, staticRenderFns } from "./ActorMessageBySetting.vue?vue&type=template&id=57b1cf41"
import script from "./ActorMessageBySetting.vue?vue&type=script&lang=js"
export * from "./ActorMessageBySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports